import React, { useState } from 'react';
import T from 'i18n-react';
import styled from 'styled-components';

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandCircleDownIcon from '@mui/icons-material/ExpandCircleDown';

import { SERVICE_COLOR } from '../../../../core/styles/variables';

const ReasonAccordion = () => {
  const [expanded, setExpanded] = useState(false);

  const toggleAccordion = () => {
    setExpanded(!expanded);
  };

  return (
    <StyledAccordion expanded={expanded} onClick={toggleAccordion}>
      <StyledAccordionSummary expandIcon={<StyledExpandCircleDownIcon />}>
        {T.translate('applicant.new.ReasonAccordion.title')}
      </StyledAccordionSummary>
      <AccordionDetails>
        <StyledOl>
          <li>{T.translate('applicant.new.ReasonAccordion.message1')}</li>
          <li>{T.translate('applicant.new.ReasonAccordion.message2')}</li>
          <li>{T.translate('applicant.new.ReasonAccordion.message3')}</li>
          <li>{T.translate('applicant.new.ReasonAccordion.message4')}</li>
        </StyledOl>
      </AccordionDetails>
    </StyledAccordion>
  );
};

export default ReasonAccordion;

const StyledAccordion = styled(Accordion)`
  && {
    margin: 4px 0 12px !important; // 展開時にmarginが変わるので、!importantをつける
    border-radius: 8px;
    border: 2px solid ${SERVICE_COLOR};
    box-shadow: none;
    cursor: pointer;

    &:hover {
      background-color: #fff4ea;
    }
  }
`;

const StyledExpandCircleDownIcon = styled(ExpandCircleDownIcon)`
  color: ${SERVICE_COLOR};
`;

const StyledAccordionSummary = styled(AccordionSummary)`
  && {
    color: ${SERVICE_COLOR};
    font-weight: bold;
    min-height: 35px;

    .Mui-expanded & {
      min-height: 35px;
    }
  }

  & .MuiAccordionSummary-content {
    margin: 8px 0;

    .Mui-expanded & {
      margin: 8px 0;
    }
  }
`;

const StyledOl = styled.ol`
  padding: 0 20px;
  margin: 0;
`;
